import { useQuery } from '@tanstack/react-query';
import { api } from '@shared/api/client';
import { COMMERCE } from '@shared/api/endpoints';
import type { StoreHealthScore, HealthSnapshot } from '@tailorcast/shared-types';

export function useStoreHealth() {
  return useQuery({
    queryKey: ['store-health'],
    queryFn: () => api.get<StoreHealthScore>(COMMERCE.KPI),
    refetchInterval: 60000,
  });
}

export function useStoreHealthTrend(days: number = 30) {
  return useQuery({
    queryKey: ['store-health', 'trend', days],
    queryFn: () => api.get<{ snapshots: HealthSnapshot[] }>(`${COMMERCE.STATS}?days=${days}`),
  });
}
